import React, { useContext, useEffect, useRef, useState } from 'react'
import { UserContext } from '../../App'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import axios from 'axios'
import Chats from '../../components/dashboard/inbox/chats'
import Conversation from '../../components/dashboard/inbox/conversation'

const Inbox = () => {

  const { auth, user, socket, showModal, setShowModal, notifications, setNotifications } = useContext(UserContext)
  const token = localStorage.getItem('token')
  const location = useLocation()
  const [selected, setSelected] = useState();
  const [chats, setChats] = useState([]);
  const [loadingChats, setLoadingChats] = useState(true)
  const [chatsOpen, setChatsOpen] = useState(true);
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate()
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (auth) {
      if (searchParams.get("chatId") !== null) {
        getChats(undefined, searchParams.get("chatId"))
      } else if (searchParams.get("book") !== null) {
        axios({
          method: 'post',
          url: '/api/draft_chat',
          data: {
            'dbId': searchParams.get("book"),
          },
          headers: {
            Authorization: `Bearer ${token}`
          }
        })
        .then(response => {
          if (response.data.type === 1) {
            getChats(response.data.chat, undefined)
          } else {
            getChats(undefined, response.data.chatId)
          }
        })
        .catch(error => {
          getChats()
        });
      } else {
        getChats()
      }
    }
  }, [auth])

  useEffect(() => {
    if (!loadingChats && searchParams.get("chatId") !== null && chats.some(a => a.chatId === searchParams.get("chatId"))) {
      setSelected(chats.find(a => a.chatId === searchParams.get("chatId")))
    }
  }, [location])

  const getChats = (draft, select) => {
    axios.get('/api/chatsGet', {
      headers: {
          Authorization: `Bearer ${token}`
      }
    })
    .then(response => {
      setChats(response.data)
      if (typeof draft !== 'undefined') {
        setChats(prevChats => {
          const newList = [...prevChats]
          newList.unshift(draft)
          setSelected(newList[0])
          return newList
        })
        setChatsOpen(false)
      } else if (typeof select !== 'undefined') {
        setSelected(response.data.find(a => a.chatId === select))
        setChatsOpen(false)
      }
      setLoadingChats(false)
    })
    .catch(error => {
      console.log(error);
    });
  }

  const selectedRef = useRef(selected); // Opret en ref til selected

  useEffect(() => {
    selectedRef.current = selected; // Opdater ref, når selected ændrer sig
    if (typeof selected !== 'undefined' && selected.messages.length > 0 && selected.messages[selected.messages.length-1].sender !== user._id && selected.messages[selected.messages.length-1].seen === false) {
      setChats(prevChats => {
        const newList = [...prevChats]; // Lav en kopi af den tidligere liste
        const chatIndex = newList.findIndex(a => a.chatId === selected.chatId);
        newList[chatIndex].messages[newList[chatIndex].messages.length-1].seen = true
        return newList
      })
      socket.emit('message_seen', selected.chatId)
      setNotifications(prev => {
        return prev.filter(a => a.chatId !== selected.chatId)
      })
    }
  }, [selected]);

  useEffect(() => {
    if (typeof selected !== 'undefined' && notifications.some(a => a.chatId === selected.chatId)) {
      setNotifications(prev => {
        return prev.filter(a => a.chatId !== selected.chatId)
      })
    }
  }, [notifications])

  useEffect(() => {
    socket.on('new_message', (data) => {
      setChats(prevChats => {
        const newList = [...prevChats]; // Lav en kopi af den tidligere liste
        const chatIndex = newList.findIndex(a => a.chatId === data.chatId);
        
        if (chatIndex !== -1) {
          if (data.messages[data.messages.length-1].sender !== user._id && typeof selectedRef.current !== 'undefined' && selectedRef.current.chatId === data.chatId) {
            data.messages[data.messages.length-1].seen = true
            socket.emit('message_seen', data.chatId)
          }
          // Hvis chatten findes, opdater beskederne
          newList[chatIndex].messages = data.messages;
        
          const updatedChat = newList[chatIndex];
          
          newList.splice(chatIndex, 1);

          newList.unshift(updatedChat);
        }
        return newList; // Returner den opdaterede liste
      });
    });

    socket.on('new_chat', (data) => {
      if (data.type === 1 && !chats.some(a => a.chatId === data.chatId)) {
        setChats(prevChats => {
          const newList = [...prevChats]
          newList.unshift(data)
          return newList
        })
      }
    })
    
    return () => {
      socket.off('new_message'); // Fjern lytteren, når komponenten afmonteres
      socket.off('new_chat');
    };
  }, [])

  useEffect(() => {
    if (!showModal && !auth && !isFirstRender.current) {
      navigate('/')
      return;
    }
    if (isFirstRender.current) {
      isFirstRender.current = false;
    }
    if (!auth) {
      setShowModal(true)
    }
  }, [showModal])

  return (
    <div className="innerContainer mx-auto flex gap-x-10 pt-[104px] pb-5 lg:pt-[106px] h-lvh">
      <div className="w-full">
        <div className="flex flex-col gap-8 h-full justify-between">
          <div className="inbox w-full h-full shadow-lg flex overflow-hidden relative">
            <Chats chats={chats} selected={selected} setSelected={setSelected} setChatsOpen={setChatsOpen} chatsOpen={chatsOpen} loadingChats={loadingChats} />
            <Conversation selected={selected} setSelected={setSelected} chats={chats} setChats={setChats} setChatsOpen={setChatsOpen} loadingChats={loadingChats} />
          </div>
        </div>
      </div>
    </div>
  )

}

export default Inbox